import React, {useState} from "react";
import {ConfirmationModal, CustomModal, Spinner} from "../../shared";
import {FormattedMessage, useIntl} from "react-intl";
import FileRow from "../myDrive/fileRow/fileRow";
import storage from "../../../utils/storageFirebase";
import functions from "../../../utils/functionsFirebase";
import drive from "../index";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import users from "../../users";

function RecycleBin() {

    const dispatch = useDispatch();
    const intl = useIntl();
    const [currentDeleting, setCurrentDeleting] = useState(null);
    const currentFolderId = useSelector(drive.selectors.getCurrentFolderId);
    const trashFiles = useSelector(drive.selectors.getTrashItems);

    async function deleteAllTrash() {
        dispatch(drive.actions.setAllFilesTrashLoading());
        const deleteTrash = functions.httpsCallable("deleteAllTrash");
        const res = await deleteTrash();
        dispatch(users.actions.deletedFilesReduceSize([{size: res.data.deletedSize}]));
        dispatch(drive.actions.setTrashFiles([]));
        toast.success(intl.formatMessage({id: "drive.recycle-bin.deleted-trash"}))
    }

    async function deleteFile(file) {
        dispatch(drive.actions.setFileTrashLoading(file.id, true));
        const deleteFiles = functions.httpsCallable("deleteFileDetails");
        await deleteFiles({id: file.id});
        dispatch(drive.actions.removeFileFromTrash(file.id));
        dispatch(users.actions.deletedFilesReduceSize([file]));
        setCurrentDeleting(null);
    }

    async function deleteFolder(folder) {
        dispatch(drive.actions.setFileTrashLoading(folder.id, true));

        const deleteFolderFromTrash = functions.httpsCallable("deleteFolderFromTrash");
        const result = await deleteFolderFromTrash({folderId: folder.id});
        dispatch(drive.actions.removeFileFromTrash(folder.id));
        dispatch(users.actions.deletedFilesReduceSize([{size: result.data.deletedSize}]));
        setCurrentDeleting(null);
    }

    async function restoreFile(file) {
        dispatch(drive.actions.setFileTrashLoading(file.id, true));
        const restoreFile = functions.httpsCallable("restoreFile");
        await restoreFile({id: file.id, currentFileId: currentFolderId, isFolder: false});
        dispatch(drive.actions.setFileTrashLoading(file.id, false));
        dispatch(drive.actions.uploadedNewFile(file));
        dispatch(drive.actions.removeFileFromTrash(file.id));
    }

    async function restoreFolder(folder) {
        dispatch(drive.actions.setFileTrashLoading(folder.id, true));
        const restoreFile = functions.httpsCallable("restoreFile");
        await restoreFile({id: folder.id, currentFileId: currentFolderId, isFolder: true});
        dispatch(drive.actions.setFileTrashLoading(folder.id, false));
        dispatch(drive.actions.folderCreated(folder));
        dispatch(drive.actions.removeFileFromTrash(folder.id));
    }

    return (
        <div>
            <CustomModal modalName="recycleBinModal"
                         content={
                             <div>
                                 <div className="modal-header">
                                     <h5 className="modal-title"><FormattedMessage id="drive.recycle-bin"/></h5>
                                     <button className="btn btn-outline-danger  btn-sm ms-3" onClick={() => {
                                         setCurrentDeleting({allFiles: true});
                                         document.getElementById("recycleBinModalButton").click();
                                         document.getElementById("confirmDeleteButton").click();
                                     }}>
                                         <FormattedMessage id="drive.recycle-bin.clean-bin"/>
                                         <i className="fa-solid fa-recycle ms-2"></i>
                                     </button>
                                     <button type="button" className="btn-close" data-bs-dismiss="modal"
                                             aria-label="Close"></button>
                                 </div>
                                 <div className="modal-body">
                                     {(trashFiles.length > 0) && <div className="list-group">
                                         {trashFiles.map(file =>
                                             file && <div key={file.id}>
                                                 <FileRow selected={false} isFolder={!file?.fileName}
                                                          onRestore={file?.fileName ? restoreFile : restoreFolder}
                                                          loading={file?.loading}
                                                          onClick={() => {
                                                          }} onDelete={() => {
                                                     setCurrentDeleting(file);
                                                     document.getElementById("recycleBinModalButton").click();
                                                     document.getElementById("confirmDeleteButton").click();
                                                 }} params={file}>
                                                 </FileRow>
                                             </div>)}
                                     </div>}
                                     {(trashFiles.length === 0) &&
                                         <div className="alert alert-info" role="alert">
                                             <FormattedMessage id="drive.no-recycle-bin.no-files"/>
                                         </div>}
                                 </div>
                             </div>}/>
            <ConfirmationModal
                open={currentDeleting !== null}
                modalName={"confirmDelete"}
                onClose={async res => {
                    if (res) {
                        if (currentDeleting?.fileName) {
                            deleteFile(currentDeleting);
                        } else if (currentDeleting.allFiles) {
                            deleteAllTrash();
                        } else {
                            deleteFolder(currentDeleting);
                        }
                    } else {
                        setTimeout(() => setCurrentDeleting(null), 120);
                    }
                    document.getElementById("recycleBinModalButton").click();
                }}
                title={!currentDeleting?.allFiles ?
                    <div>
                        <FormattedMessage id="drive.recycle-bin.confirm-delete.title"/>
                    </div> :
                    <div>
                        <FormattedMessage id="drive.recycle-bin.confirm-delete-all.title"/>
                        <i className="fa-solid fa-recycle ms-2"></i>
                    </div>
                }
                message={!currentDeleting?.allFiles ?
                    <div>
                        <FormattedMessage id="drive.recycle-bin.confirm-delete.message"/>
                        <div className="mb-3"></div>
                        <FileRow selected={false} isFolder={currentDeleting?.folderName}
                                 params={currentDeleting} changeName={false} onClick={() => {
                        }}>
                        </FileRow>
                    </div> :
                    <div>
                        <FormattedMessage id="drive.recycle-bin.confirm-delete-all.message"/>
                    </div>
                }
                btnClass="btn-danger" confirmText={intl.formatMessage({id: "drive.delete-selected"})}/>
            <button id="confirmDeleteButton" style={{display: 'none'}} data-bs-toggle="modal"
                    data-bs-target={"#confirmDelete"} data-bs-dismiss="modal"/>
            <button id="recycleBinModalButton" style={{display: 'none'}} data-bs-toggle="modal"
                    data-bs-target={"#recycleBinModal"}/>
        </div>

    )
}

export default RecycleBin;
